import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import "./LowPenetrationsDropdown.scss";
import cn from "classnames";
import { cssX, SelectComponent } from "@datassential/platform-ui-lib";

const LowPenetrationDropdown = ({
    includeLowPenetrationItems,
    includeLessTenMenusCount,
    setIncludeOptions,
}) => {
    const [isOpened, setIsOpened] = useState(false);

    const optionsLowPenetration = useMemo(
        () => [
            {
                title: "Items > 1%",
                isActive: !includeLowPenetrationItems && includeLessTenMenusCount,
                onClick: () => {
                    setIncludeOptions({
                        includeLowPenetrationItems: false,
                        includeLessTenMenusCount: true
                    });
                }
            },
            {
                title: "Items > 10 menus",
                isActive: includeLowPenetrationItems && !includeLessTenMenusCount,
                onClick: () => {
                    setIncludeOptions({
                        includeLowPenetrationItems: true,
                        includeLessTenMenusCount: false
                    });
                },
            },
            {
                title: "All items",
                isActive: includeLowPenetrationItems && includeLessTenMenusCount,
                onClick: () => {
                    setIncludeOptions({
                        includeLowPenetrationItems: true,
                        includeLessTenMenusCount: true
                    });
                },
            },
        ],
        [includeLowPenetrationItems, includeLessTenMenusCount, setIncludeOptions]
    );

    const title = useMemo(
        () => {
            const activeOption = optionsLowPenetration.find(option => option.isActive);
            return activeOption ? activeOption.title : "Select option";
        },
        [optionsLowPenetration]
    );

    // return (
    //     <div
    //         className="TopTrendsSidebar__radio toggle-input"
    //     >
    //         <button
    //             onClick={handleLowPenetrationClick}
    //             className="low-penetration-btn"
    //         >
    //             {title}
    //             <Icon
    //                 type="small"
    //                 className="low-penetration-btn__icon-arrow"
    //             >
    //                 <IconArrowBottom />
    //             </Icon>
    //         </button>
    //         <div
    //             className="low-penetration-dropdown"
    //         >
    //             <KeywordMenu
    //                 x={lowPenetrationX}
    //                 y={lowPenetrationY}
    //                 closeModal={() => dispatch({ isLowPenetrationDropdownShown: false })}
    //                 shown={isLowPenetrationDropdownShown}
    //                 options={optionsLowPenetration}
    //             />
    //         </div>
    //     </div>
    // )

    return (
        <div className="low-penetration-btn">
            <SelectComponent
                thumbnailText={title}
                isOpened={isOpened}
                setIsOpened={setIsOpened}

                dropdownProps={{
                    isInPortal: true,
                    isOpened: isOpened,
                    place: "bottom-start",
                    columns: [{
                        id: 'id',
                        title: '',
                        items: [],
                        content: <>
                            {optionsLowPenetration.map(i => (
                                <div
                                    key={i.id}
                                    className={cn(cssX("Dropdown__row"))}
                                >
                                    <div
                                        className={cn(
                                            cssX('Dropdown__item'),
                                            cssX('SelectComponent__item'),
                                            i.isActive && 'active-accessible',
                                        )}
                                        onClick={() => {
                                            i.onClick();
                                            setIsOpened(false);
                                        }}
                                    >
                                        {i.title}
                                    </div>
                                </div>
                            ))}
                        </>,
                    }],
                }}
            />
        </div>
    );
};

export default connect()(LowPenetrationDropdown);